<template>
  <svg width="24" height="32" viewBox="0 0 24 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0 4C0 1.79086 1.79086 0 4 0H24V32H4C1.79086 32 0 30.2091 0 28V4Z" fill="#F9F9F9"/>
<path d="M7.33398 11.666C7.33398 12.2193 7.78065 12.666 8.33398 12.666H11.0007V19.666C11.0007 20.2193 11.4473 20.666 12.0007 20.666C12.554 20.666 13.0007 20.2193 13.0007 19.666V12.666H15.6673C16.2207 12.666 16.6673 12.2193 16.6673 11.666C16.6673 11.1127 16.2207 10.666 15.6673 10.666H8.33398C7.78065 10.666 7.33398 11.1127 7.33398 11.666Z" fill="#8DA0A9"/>
</svg>

</template>

<script>
export default {

}
</script>

<style>

</style>